import { cn } from '@/context/global/utils/cn';

export type IconVolumeMuteProps = {
  className?: string;
  size?: number;
};

export default function IconVolumeMute({
  className = '',
  size = 32,
}: IconVolumeMuteProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M2.66699 13.3334V18.6667C2.66699 21.3334 4.00033 22.6667 6.66699 22.6667H8.58699C9.13366 22.6667 9.66699 22.8267 10.1337 23.1067L14.2003 25.64C17.6137 27.7734 20.4003 26.1467 20.4003 22.0934V9.90671C20.4003 5.84004 17.6137 4.22671 14.2003 6.36004L10.1337 8.89337C9.66699 9.17337 9.13366 9.33337 8.58699 9.33337H6.66699C4.00033 9.33337 2.66699 10.6667 2.66699 13.3334Z"
        fill="currentColor"
      />
      <path
        d="M29.3337 12.6667L24.667 17.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3337 17.3334L24.667 12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
